import { Injectable } from '@angular/core';
import {
    BaseHttpService,
    GetById,
    Update,
    UriBuilderParams
} from '@app/core/services/base/base-http.service';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';
import { Observable } from 'rxjs';
import { DrQueryParams } from '@app/core/services/base/base-service-with-bundle.service';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { CaseNoSettings } from '@app/shared/models/case-number-settings';

export class CaseNoSettingsUriBuilderParams extends UriBuilderParams<CaseNoSettings> {

    constructor() {
        super();
    }

    public buildUri(): string {
        return `/${BackendUriUnits.CASE_NO}/${BackendUriUnits.SETTINGS}`;
    }
}

@Injectable({ providedIn: 'root' })
export class CaseNumberService extends BaseHttpService<CaseNoSettings, CaseNoSettingsUriBuilderParams>
                               implements GetById<CaseNoSettings, CaseNoSettingsUriBuilderParams>,
                                          Update<CaseNoSettings, CaseNoSettingsUriBuilderParams> {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(CaseNoSettings, httpServiceBundle);
    }

    // BASE METHODS ****************************************************************************************

    // The getById method for the CaseNoSettings does not use the ID. It gets the entire case number structure for the client, and there is only 1
    public getById(uriParams: CaseNoSettingsUriBuilderParams, params?: DrQueryParams, propOverride?: string): Observable<CaseNoSettings> {
        return this.getBaseById(uriParams, params, propOverride);
    }

    public update(uriParams: CaseNoSettingsUriBuilderParams, toUpdate: CaseNoSettings, params?: DrQueryParams): Observable<CaseNoSettings> {
        return this.updateBase(uriParams, toUpdate, params);
    }

}
